var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Mixins, Prop } from 'vue-property-decorator';
import AttachmentControl from "@/common/components/AttachmentControl.vue";
import { Attachment } from "@/common/types/Attachment";
import { Savable } from '@/common/mixins/Savable';
import { Validatable } from '@/common/mixins/Validatable';
import { ValidationProvider } from 'vee-validate';
var AttachmentsWrapper = /** @class */ (function (_super) {
    __extends(AttachmentsWrapper, _super);
    function AttachmentsWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // List of attachment indices which are currently being uploaded to the server
        _this.uploading = [];
        return _this;
    }
    AttachmentsWrapper.prototype.startUpload = function (event, index) {
        this.touch();
        this.change();
        this.uploading.push(index);
    };
    AttachmentsWrapper.prototype.stopUpload = function (event, index) {
        this.uploading.splice(this.uploading.indexOf(index), 1);
    };
    AttachmentsWrapper.prototype.addedAttachment = function (event, attachment) {
        attachment.blobUri = event;
        this.$emit('added-attachment', attachment);
        this.blur();
    };
    AttachmentsWrapper.prototype.deletedAttachment = function (event, attachment) {
        attachment.blobUri = null;
        this.forceSave();
    };
    Object.defineProperty(AttachmentsWrapper.prototype, "attachmentSettings", {
        get: function () {
            return this.$store.getters["vuexPageModule/attachmentSettings"];
        },
        enumerable: false,
        configurable: true
    });
    AttachmentsWrapper.prototype.attachmentFileNameClass = function (fileName) {
        if (this.isDuplicatedFileName) {
            return "button-sized-text validation-error";
        }
        return "button-sized-text";
    };
    var _a;
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], AttachmentsWrapper.prototype, "inputId", void 0);
    __decorate([
        Prop(Object),
        __metadata("design:type", typeof (_a = typeof Attachment !== "undefined" && Attachment) === "function" ? _a : Object)
    ], AttachmentsWrapper.prototype, "attachment", void 0);
    __decorate([
        Prop({
            type: Number,
            default: 1
        }),
        __metadata("design:type", Number)
    ], AttachmentsWrapper.prototype, "index", void 0);
    __decorate([
        Prop({ type: Boolean, default: true }),
        __metadata("design:type", Boolean)
    ], AttachmentsWrapper.prototype, "notifyonuploadedsuccess", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], AttachmentsWrapper.prototype, "isDuplicatedFileName", void 0);
    AttachmentsWrapper = __decorate([
        Component({
            name: "AttachmentWrapper",
            components: {
                AttachmentControl: AttachmentControl,
                ValidationProvider: ValidationProvider
            }
        })
    ], AttachmentsWrapper);
    return AttachmentsWrapper;
}(Mixins(Savable, Validatable)));
export default AttachmentsWrapper;
